import init from '../accordion/dist/uswitch-ev-utils-critical-accordion.esm.js';
import init$1 from '../accordion-preview/dist/uswitch-ev-utils-critical-accordion-preview.esm.js';
import init$2 from '../tabs/dist/uswitch-ev-utils-critical-tabs.esm.js';
import init$3 from '../tracking/dist/uswitch-ev-utils-critical-tracking.esm.js';
import init$4 from '../carousel/dist/uswitch-ev-utils-critical-carousel.esm.js';
import '@babel/runtime/helpers/toConsumableArray';
import '../../dist/objectSpread2-811c5212.esm.js';
import '@babel/runtime/helpers/typeof';
import '@babel/runtime/helpers/slicedToArray';

init();
init$1();
init$2();
init$3();
init$4();
